<template>
  <div class="h-full">
    <loading-spinner :loading="loading"></loading-spinner>
    <router-view/>
  </div>
</template>

<script>
import LoadingSpinner from "@/app/components/LoadingSpinner.vue";
import UserService from "~/app/services/UserService.js";
import RestService from "~/app/services/RestService.js";

export default {
  name: 'ToolApp',
  components: {
    LoadingSpinner
  },
  data() {
    return {
      model: nimbleai.model
    }
  },
  computed: {
    loading() {
      return this.model.loading
    }
  },
  mounted() {
    const service = new RestService('users')
    let url = '/api/v1/users/current'
    service.executeGet(url).then((response) => {
      this.model.user = response
      nimbleai.services.userService = new UserService(this.model.user)
      nimbleai.services.llmService = new RestService('foundation-models', '/')

      nimbleai.services.llmService.list().then((foundationModels) => {
        this.model.foundationModels = foundationModels
      }).catch((message) => {
        console.log('error loading foundation models')
        console.log(message)
      })
    }).catch((message) => {
      console.log('error loading current user')
      console.log(message)
      
      // Store the current route before redirecting
      this.model.intendedRoute = {
        name: this.$route.name,
        path: this.$route.path,
        params: this.$route.params,
        query: this.$route.query
      }
      
      this.$router.push({ name: 'sign-up' })

      url = '/current-config'
      service.executeGet(url).then((response) => {
        this.model.whitelabelConfig = response
      }).catch((message) => {
        console.log('error loading current whitelabel config')
        console.log(message)
      })
    })
  }
}
</script>
